/**
 * 경량 편집 스냅샷 — 결정 #30. AI 수리/자동수리처럼 코드를 통째로 교체하는 동작 전에
 * 현재 상태를 스냅샷으로 남겨, 사용자가 "되돌리기"로 복구할 수 있게 한다. 풀 git(후속
 * 단계)과 달리 세션 한정·경량이며, 핵심 목적은 "AI가 망친 편집을 즉시 되돌리기"다.
 *
 * 순수 함수(결정 #10): 바운드 스택 관리만. 저장/UI는 web이 담당한다.
 */

export interface EditSnapshot {
  /** 그 시점의 전체 소스. */
  value: string;
  /** 사람이 읽는 설명(예: "AI 수리 전", "자동 수리 전"). */
  label: string;
  /** 생성 시각(epoch ms). */
  at: number;
}

/** 스냅샷 스택 기본 상한(가장 오래된 것부터 버린다). */
export const DEFAULT_SNAPSHOT_CAP = 30;

/**
 * 스냅샷을 스택에 추가한다(불변). 직전 스냅샷과 value가 같으면 중복으로 보고 추가하지
 * 않는다(연속 no-op 방지). 상한을 넘으면 가장 오래된 것부터 버린다.
 */
export function pushSnapshot(
  stack: EditSnapshot[],
  snap: EditSnapshot,
  cap: number = DEFAULT_SNAPSHOT_CAP,
): EditSnapshot[] {
  const last = stack[stack.length - 1];
  if (last && last.value === snap.value) return stack; // 동일 내용 → 무시
  const next = [...stack, snap];
  return next.length > cap ? next.slice(next.length - cap) : next;
}

/**
 * 가장 최근 스냅샷을 꺼내 복구 대상으로 반환한다(불변). 되돌리기 1회에 해당.
 * 빈 스택이면 undefined.
 */
export function popSnapshot(
  stack: EditSnapshot[],
): { restored: EditSnapshot; rest: EditSnapshot[] } | undefined {
  if (stack.length === 0) return undefined;
  const restored = stack[stack.length - 1]!;
  return { restored, rest: stack.slice(0, -1) };
}
